import { jsxs as o, jsx as l } from "react/jsx-runtime";
const i = (e) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25",
    ...e,
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#magento-colored_svg__a)", children: /* @__PURE__ */ l("g", { clipPath: "url(#magento-colored_svg__b)", children: /* @__PURE__ */ l(
        "path",
        {
          fill: "#EC6737",
          d: "M13.58 7.353v16.143l-1.588.97-1.588-.976V7.366L6.29 9.898v13.805l5.702 3.49 5.75-3.515V9.89zm-1.588-8.5L0 6.117v13.807l3.115 1.835V7.952l8.88-5.4 8.888 5.392.037.02-.004 13.775L24 19.925V6.118z"
        }
      ) }) }),
      /* @__PURE__ */ o("defs", { children: [
        /* @__PURE__ */ l("clipPath", { id: "magento-colored_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 .85h24v24H0z" }) }),
        /* @__PURE__ */ l("clipPath", { id: "magento-colored_svg__b", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0-1.15h24v28.41H0z" }) })
      ] })
    ]
  }
);
export {
  i as default
};
